import { RequestStatus, RequestTable, RequestTableTypes } from "../types";
import { requestStartPassed } from "./requestStartPassed";

export const getRequestTableStatus = (request: RequestTable) => {
    if (requestStartPassed(request.date, request.startTime)) return RequestTableTypes.Archive;
    else if (request.status === RequestStatus.Closed) return RequestTableTypes.Closed;
    return RequestTableTypes.Pending;
}